import { useEffect, useState } from "react";
import { Bell, BellOff, Sparkles } from "lucide-react";
import { isPushSubscribed, subscribeToPush, sendTestPush } from "@/lib/push";
import { toast } from "sonner";

export default function PushPrompt() {
  const [subscribed, setSubscribed] = useState(null);
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    (async () => {
      try {
        setSubscribed(await isPushSubscribed());
      } catch (_) {
        setSubscribed(false);
      }
    })();
  }, []);

  if (subscribed === null) return null;
  if (subscribed) {
    return (
      <button
        onClick={async () => { try { await sendTestPush(); toast.success("Push enviado."); } catch (_) { toast.error("Falha ao enviar push de teste."); } }}
        className="inline-flex items-center gap-2 text-xs text-muted-foreground hover:text-primary transition-colors"
        data-testid="push-test-btn"
      >
        <Bell className="w-3.5 h-3.5" /> Notificações ativas — enviar teste
      </button>
    );
  }

  const enable = async () => {
    setBusy(true);
    try {
      await subscribeToPush();
      setSubscribed(true);
      toast.success("Notificações ativadas!");
    } catch (e) {
      toast.error(e.message || "Não foi possível ativar notificações.");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="bg-card border border-border rounded-sm p-5 flex items-start gap-4" data-testid="push-prompt">
      <div className="w-10 h-10 rounded-sm bg-accent/10 text-accent grid place-items-center flex-none">
        <BellOff className="w-5 h-5" />
      </div>
      <div className="flex-1">
        <div className="overline text-muted-foreground mb-1 flex items-center gap-2"><Sparkles className="w-3 h-3" /> Lembretes inteligentes</div>
        <div className="font-heading font-semibold">Ative as notificações</div>
        <div className="text-sm text-muted-foreground mt-1">Receba lembretes de check-in semanal, próxima aplicação injetável e consultas direto no navegador.</div>
      </div>
      <button
        onClick={enable} disabled={busy}
        className="rounded-sm bg-primary text-primary-foreground px-4 py-2 text-sm font-semibold hover:bg-primary/90 disabled:opacity-60 transition-colors flex-none"
        data-testid="push-enable-btn"
      >
        {busy ? "Ativando…" : "Ativar"}
      </button>
    </div>
  );
}
